import React from 'react';

const Benefits: React.FC = () => {
  const benefits = [
    {
      number: '01',
      title: '100% Cumplimiento DIAN',
      description: 'Certificación oficial y cumplimiento garantizado con todas las regulaciones colombianas.'
    },
    {
      number: '02',
      title: 'Solución Todo-en-Uno',
      description: 'No necesitas múltiples sistemas. Una sola plataforma para todas tus operaciones empresariales.'
    },
    {
      number: '03',
      title: 'Multi-Sucursal',
      description: 'Escala a través de múltiples ubicaciones con control centralizado y reportes específicos.'
    }
  ];

  return (
    <section className="benefits" id="soluciones">
      <div className="container">
        <div className="section-header">
          <h2>¿Por qué elegir APOLOX?</h2>
          <p>Puntos clave que nos diferencian de la competencia</p>
        </div>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-item">
              <div className="benefit-number">{benefit.number}</div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;